import hh from 'hyperscript-helpers';
import { h } from 'virtual-dom';
import { emailInputMsg, loginMsg, pinCodeInputMsg, requestPinMsg,
         emailForPinInputMsg, showOrderPinMsg, showLoginMsg, showUploadMsg, showTermsMsg, termsInputMsg, logoutMsg } from "../Update";
import { getSubmitButton } from './View.js';
const { div, p, main, fieldset, legend, input,button, form, a, label, h4, span, br } = hh(h);

function logoutBox(dispatch, model) {
    return main({ className: 'mt4 pv3 black-80 w-60-ns center bg-white-90' }, [
        fieldset( { id: 'logout', className:'ba b--transparent ph0 mh0'}, [
                legend( { className: 'tc f3 f2-m f2-l fw2 black-90 mv3' } , 'Log ud'),
                div({ className: 'tc', }, [
                    p( {}, 'Klik på knappen herunder for at logge ud.'),
                    a( { className: 'f6 b link dim br-pill ph3 pv2 mb2 dib white bg-black pointer db', onclick: () => dispatch(logoutMsg) }, 'LOG UD' )
                ]),
        ])
    ]);
}
function loginBox(dispatch, model) {
    const btnDisabled = (!model.login.pinCode || !model.login.email) ? 'disabled' : '';
    return main({ className: 'mt4 pv3 black-80 w-60-ns center bg-white-90' }, [

        form(
            {
                className: 'measure center',
                onsubmit: e => {
                    e.preventDefault();
                    dispatch(loginMsg);
                },
            },
            [
                fieldset( { id: 'login', className:'ba b--transparent ph0 mh0'}, [
                    legend( { className: 'tc f3 f2-m f2-l fw2 black-90 mv3' } , 'Log ind'),
                    div({ className: 'mt3' }, input({
                        className: 'pa2 input-reset ba br2 bg-transparent hover-black-80 w-100',
                        placeholder: 'Email',
                        id: 'loginEmail',
                        type: 'text',
                        value: model.login.email,
                        oninput: e => dispatch(emailInputMsg(e.target.value)),
                        })
                    ),
                    div({ className: 'mv3' }, input({
                        className: 'pa2 input-reset ba br2 bg-transparent hover-black-80 w-100',
                        placeholder: 'Pinkode',
                        type: 'password',
                        oninput: e => dispatch(pinCodeInputMsg(e.target.value)),
                        }),
                    ),
                ]),
                model.login.error ? div( { id: 'errorMessage', className: 'tc red mb2 b' }, p( { className: '' }, model.login.error)) : '',
                div({  className: 'tc' },
                    getSubmitButton('Log ind', btnDisabled)
                ),
                div( { className: 'lh-copy tc mt3' }, a( { className: 'f6 link dim black db pointer', onclick: () => dispatch(showOrderPinMsg)}, 'Bestil ny pinkode') ),
                div( { className: 'lh-copy tc mt3' }, a( { className: 'f6 link dim black db pointer', onclick: () => dispatch(showUploadMsg)}, 'Indsend rapport') )
            ],
        ),
    ]);
}
function orderPinBox(dispatch, model) {
    const btnDisabled = model.login.emailForPin && model.terms_accepted ? '' : 'disabled';
    return main({ className: 'mt4 pv3 black-80 w-60-ns center bg-white-90' }, [

        form(
            {
                className: 'measure center',
                onsubmit: e => {
                    e.preventDefault();
                    dispatch(requestPinMsg);
                },
            },
            [
                fieldset( { id: 'orderPin', className:'ba b--transparent ph0 mh0'}, [
                    legend( { className: 'tc f3 f2-m f2-l fw2 black-90 mv3' } , 'Bestil ny pinkode'),
                    div({ className: 'mt3' }, input({
                            className: 'pa2 input-reset ba br2 bg-transparent hover-black-80 w-100',
                            placeholder: 'Email',
                            value: model.login.emailForPin,
                            type: 'text',
                            id: 'orderPinEmail',
                            oninput: e => dispatch(emailForPinInputMsg(e.target.value)),
                        })
                    ),
                ]),
                div({  className: 'db tc pa2 mb2' }, [
                    input({
                        className: 'h1 w1 v-mid',
                        type: 'checkbox',
                        id: 'disclaimer',
                        onclick: e => dispatch(termsInputMsg),
                        required: true
                    }),
                    label( { className: 'ml1 v-mid f5 mr1' } , [
                        'Godkend ',
                        a( { className: 'underline pointer', onclick: () => dispatch(showTermsMsg) }, 'betingelser' )
                    ]),
                    model.terms ? div( { className: 'tl bg-light-gray gray overflow-hidden pa2 f6 mt1'}, [
                        p( { className: 'b' }, 'Betingelser for brug'),
                        p( { className: 'pt1 i' }, 'Ved at godkende betingelserne giver du tilladelse til følgende:'),
                        p( {}, [
                            'Vi må benytte din e-mailadresse, når du anvender siden til at indsende rapporter. Den bliver gemt i vores systemer til at sende dig en pinkode, som skal angives ved oprettelse af grundvandsrapporter.',
                            br(),
                            'Vi må kontakte dig via din e-mailadresse i forbindelse med de grundvandsrapporter, du indsender.' ,
                            br(),
                            'Vi må gemme det indhold, du indsender, når du bruger siden til at oprette grundvandsrapporter. Det omfatter f.eks. e-mailadresse, fotos og dokumenter. ',
                            br(),
                            'Ved indsendelse til GEUS står indberetteren (brugeren) inde for, at grundvandsrapporternes indhold må udstilles offentligt.',
                            br(),
                            'GEUS fraskriver sig ansvar for at det indhold som indsendes i grundvandsrapporterne, er korrekt. Det ansvar påhviler den bruger, der indsender pågældende grundvandsrapport.'
                        ]),
                        p( { className: 'pt1 b' }, 'Cookies'),
                        p( {}, 'Denne hjemmeside anvender cookies. Disse er funktionelle cookies, som alene anvendes når man logger ind. Der anvendes ikke cookies til statistik- og markedsføringsformål og der deles ikke information med nogen tredjepart.'),
                        p( {  className: 'pt1 b' }, 'Generelt'),
                        p( {}, [
                            'Hvis du ønsker at få slettet din e-mailadresse fra vores systemer, bedes du kontakte os her: ',
                            a( { className: 'f6 link dim black pointer', href: 'mailto:jupiter@geus.dk?subject=Jeg%20vil%20gerne%20have%20slettet%20min%20e-mail%20i%20jeres%20rapportdatabase' } , 'jupiter@geus.dk.'),
                            br(),
                            'Generel information om GEUS\' privatlivspolitik kan findes her: ',
                            a( { className: 'f6 link dim black db pointer', href: 'https://www.geus.dk/om-geus/privatlivspolitik', target: '_blank' }, 'https://www.geus.dk/om-geus/privatlivspolitik.')
                        ]),
                    ])
                    : ''
                ]),
                model.login.error ? div( { id: 'errorMessage', className: 'tc red mb2 b' }, p( { className: '' }, model.login.error)) : '',
                model.login.emailSent ? div( { id: 'succesMessage', className: 'tc green mb2 b' }, p( { className: '' }, 'Email med pinkode er sendt.')) : '',
                div({  className: 'tc' },
                    getSubmitButton('Bestil', btnDisabled)
                ),
            ],
        ),
        div( { className: 'lh-copy tc mt3' }, a( { className: 'f6 link dim black db pointer', onclick: () => dispatch(showLoginMsg)}, 'Log ind') )
    ]);
}

function sessionExpiredBox(model) {
    if (model.error) {
        return div( { className: 'b pa2 tc red-80' }, model.error);
    }
    return '';
}
export function loginView(dispatch, model) {
    if (model.state === 'login') {
        if (model.login.loggedin) {
            return div({className: ''}, [
                logoutBox(dispatch, model)
            ]);
        }
        return div({className: ''}, [
            sessionExpiredBox(model),
            loginBox(dispatch, model),
        ]);
    }
    if (model.state === 'orderPin') {
        return div({className: ''}, [
            orderPinBox(dispatch, model),
        ]);
    }
    return div({ className: 'mv2 i black-50' }, 'Not in login state...');

}